import Vue from 'vue'

import toast from './toast'

Vue.mixin(toast)
